export default __webpack_public_path__ + "9006a9b3cc01629e74458b7e961965b2.svg";